import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'yi-layout',
  template: require('./layout.component.html'),
  styles: [require('./layout.component.scss')]
})
export class LayoutComponent implements OnInit {

  constructor() {}

  ngOnInit() {}

}
